import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { useCallback } from 'react';
import { TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT } from '../../../constants/Navigation';
import { getLessonBaseUrl, getTrackBaseUrl } from '../../../utils/RoutingUtils';
import { usePlaylist } from '../../savedItems';
import { usePlaylistProgress } from '../../userProgress';
import { usePlaylistIdFromSearch } from '../hooks';
import getLang from 'I18n/utils/getLang';
import useNavigate from '../../../hooks/useNavigate';
const URL_FRAGMENTS = [TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT];

const useRenderParams = ({
  contentType,
  trackId,
  lessonId,
  nextPlaylistItem,
  playlistProgress
}) => {
  const navigate = useNavigate();

  const urlBuilder = suffix => {
    if (contentType === 'TRACK' && trackId) {
      return getTrackBaseUrl(trackId.toString(), suffix);
    } else if (contentType === 'LESSON' && lessonId) {
      return getLessonBaseUrl(lessonId.toString(), suffix);
    }

    return '';
  };

  const renderParams = {
    urlFragments: URL_FRAGMENTS,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteTitle"
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteSubtitle"
    }),
    url: urlBuilder(TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT),
    language: getLang(),
    navigate: () => {}
  };

  if (playlistProgress && playlistProgress.status === 'COMPLETED') {
    renderParams.title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.completeTitle"
    });
    renderParams.url = urlBuilder(TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT);
  } else if (nextPlaylistItem) {
    const {
      itemId,
      type,
      language,
      name
    } = nextPlaylistItem;
    renderParams.trackId = type === 'TRACK' ? itemId : undefined;
    renderParams.lessonId = type === 'LESSON' ? itemId : undefined;
    renderParams.subtitle = name;
    renderParams.language = language;
    renderParams.url = urlBuilder(TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT);
  }

  const navigateToLastSection = useCallback(() => {
    navigate(location => Object.assign({}, location, {
      pathname: renderParams.url || ''
    }));
  }, [navigate, renderParams.url]);
  renderParams.navigate = navigateToLastSection;
  return renderParams;
};

export const NextPlaylistContent = ({
  trackId,
  lessonId,
  render
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);
  const {
    playlistProgress
  } = usePlaylistProgress(playlistId);
  const contentType = trackId ? 'TRACK' : 'LESSON';
  const nextPlaylistItemIndex = playlist ? playlist.items.findIndex(item => item.itemId === (trackId || lessonId) && item.type === contentType) + 1 : -1;
  const nextPlaylistItem = playlist && playlist.items[nextPlaylistItemIndex];
  const renderParams = useRenderParams({
    contentType,
    trackId,
    lessonId,
    nextPlaylistItem,
    playlistProgress
  });
  return render(renderParams);
};